
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'SIN_VIN',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/SIN_VIN.vue